export default class PopUp {
	constructor(element) {

		//  this.popUpToggle = element.querySelector('.js-popUp-toggle');
		//  this.popUpPoster = element.querySelector('.js-popUp-poster');
		 this.target = element.querySelector('.js-popUp--target');
		 this.trigger = element.querySelector('.js-popUp-trigger');
		 this.background = element.querySelector('.js-popUp__background');
		 this.cross = element.querySelector('.js-popUp__icon');
		 this.poster = element.querySelector('.popUp__poster');
		 this.video = element.querySelector('.js-video-player');

		 let getCookie = function (name) {
			var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			if (match) return match[2];
		}

		let doPopup = true;

		// init cookie-tool: pop-up off
		if (document.getElementById('eagerly-tools-cookie')) {

			doPopup = false;

		};

		// if cookies are set and settings are not default: pop-up on
		if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings') != 'default') {
			doPopup = true;
		}

		// if type is mp4: pop-up
		if ( this.video.getAttribute('data-plyr-provider') == 'mp4') {
			doPopup = true;
		}

		if ( doPopup ){
			this.poster.classList.add('noclick'); // prevent first toggle on click non-popup
			this.init();
		}

	}

	init() {
		 const togglePopUp = () => {
			  this.target.classList.toggle('js-popUp--hidden');
		 };

		 this.trigger.addEventListener('click', togglePopUp);
		 this.background.addEventListener('click', togglePopUp);
		 this.cross.addEventListener('click', togglePopUp);

		 // Handle keydown event for tab navigation
		 this.trigger.addEventListener('keydown', (event) => {
			  if (event.key === 'Enter' || event.key === 'Space') {
					togglePopUp();
			  }
		 });

		 // Handle touchstart and touchend events for iOS
		 this.trigger.addEventListener('touchstart', togglePopUp);
		 this.trigger.addEventListener('touchend', (event) => {
			  event.preventDefault(); // Prevent triggering 'click' after 'touchend'
		 });
	}
}
